import React, { useState, useEffect, useRef } from "react";
import CalendarComponent from "./CalendarComponent";
import SlotSelectionComponent from "./SlotSelectionComponent";
import { generateExcludedDates, getMaxDate, isToday } from "./utils";
import './Calender.css'

const Main = ({ formData, setFormData, errors, setErrors,  setBookingData,  bookingData, studioData, teamData}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const [excludedDates, setExcludedDates] = useState([])
  // Generate excluded dates using memoizatio  
useEffect(() => {
  
  if (!bookingData || !Object.keys(studioData).length || !teamData.length) {
    return;
  }
  // Generate excluded dates and updated booking data
  const { updatedBookingData, excludedDates } = generateExcludedDates(bookingData, studioData, teamData);
  // Only update booking data if it has changed to avoid unnecessary re-renders
  if (JSON.stringify(bookingData) !== JSON.stringify(updatedBookingData)) {
    setBookingData(updatedBookingData);
  }
  
  // Update the excludedDates directly (no need for useMemo)
  setExcludedDates(excludedDates);

}, [bookingData, studioData, teamData]);

  // Max date for booking
  const maxDate = studioData?.day_limit ? getMaxDate(studioData.day_limit) : null;

  // Handle date change
  const handleDateChange = (date) => {
    
    formData.slot_time = ""; // Reset slot on date change
    formData.team_id = ""; // Reset team on date change
    const formattedDate = date.toLocaleDateString("en-CA");
    setSelectedDate(formattedDate);

    setFormData({ ...formData, shoot_date: formattedDate, local_selected_date:formattedDate  });

    // Clear errors
    if (errors.local_selected_date) {
      setErrors((prevErrors) => {
        const { local_selected_date, ...rest } = prevErrors;
        return rest;
      });
    }
  };
  
  
  return (
    <div className="calendar-container">
      {(bookingData && studioData && teamData) && <CalendarComponent
        selectedDate={selectedDate}
        excludedDates={excludedDates}
        maxDate={maxDate}
        activeStartDate={activeStartDate}
        setActiveStartDate={setActiveStartDate}
        handleDateChange={handleDateChange}
        isToday={isToday}
        formData={formData}
      />}
      
      {(bookingData && studioData && teamData && formData.local_selected_date) && <SlotSelectionComponent
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          selectedDate={formData.local_selected_date}
          bookingData={bookingData}
          studioData={studioData}
          teamData={teamData}
        />}
   

      {errors.local_selected_date && <p className="error-message">{errors.local_selected_date}</p>}
    </div>
  );
};

export default Main;
